export default __webpack_public_path__ + "static/media/YAS0190.34I-41202_-24569_0.ba622d31.jpg";